/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { t } from '../../../locales/i18n';
import { appSettingsPath } from '../../../navigation';
import { Link } from 'react-router-dom';
import { Segment } from '../../../components/segment';
import { Button } from 'semantic-ui-react';
import { HeroContainer, HeroContent, HeroFooter, HeroHeader } from '../../../components/layout/layout-components';

export interface BoothClosedProps {
  onBoothOpen: () => void;
}

export function BoothClosed(props: BoothClosedProps) {
  return (
    <HeroContainer>
      <HeroHeader>
        <h1>{t('selectedQueue.boothClosed')}</h1>
      </HeroHeader>
      <HeroContent>
        <Segment>
          <p>{t('selectedQueue.boothClosedDescription')}</p>
        </Segment>
      </HeroContent>
      <HeroFooter>
        <Link to={appSettingsPath()}>
          <Button variant="outlined">{t('settings')}</Button>
        </Link>
        <Button primary onClick={props.onBoothOpen}>
          {t('selectedQueue.openBooth')}
        </Button>
      </HeroFooter>
    </HeroContainer>
  );
}
